<template>
  <CustDialogBox
    @closed="dialogOnCloseFn"
    @opend="dialogOpendFn"
    :show="isShow"
    title="医事通绑定"
    width="500"
  >
    <template #content>
      <div style="width: 100%; display: flex; justify-content: center">
        <div class="dialog_box">
          <el-tabs
            v-model="tabName"
            class="demo-tabs"
            @tab-change="tabchangeFn"
          >
            <!-- <el-tab-pane label="微信扫码绑定" name="weixin">
              <div class="weixin">
                <div class="image-weixin">
                  <el-image
                    style="width: 100%; height: 100%"
                    :src="qrcodeImg"
                    :fit="'contain'"
                  />
                </div>
                <div class="qrcode-tip">微信扫一扫，绑定医事通</div>
              </div>
            </el-tab-pane> -->
            <el-tab-pane label="手机号绑定" name="phone">
              <div class="phoneBox">
                <el-form
                  ref="phoneFormRef"
                  :model="phoneForm"
                  :rules="phoneRules"
                  class="code-login-form"
                >
                  <el-form-item prop="phone">
                    <el-input
                      v-model="phoneForm.phone"
                      maxlength="11"
                      placeholder="请输入手机号码"
                    >
                      <template #prefix>
                        <i class="icon-line47 font_family input-icon-font"></i>
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="code">
                    <div class="code-input-wrapper">
                      <el-input
                        v-model="phoneForm.code"
                        placeholder="请输入验证码"
                        class="code-input"
                      >
                        <template #prefix>
                          <i
                            class="icon-line48 font_family input-icon-font"
                          ></i>
                        </template>
                      </el-input>
                      <el-button
                        @click="sendCode"
                        :disabled="isCounting"
                        type="primary"
                        class="code-btn"
                      >
                        {{ buttonText }}
                      </el-button>
                    </div>
                  </el-form-item>
                  <el-form-item class="login-btn-item">
                    <el-button
                      type="primary"
                      class="login-btn-full"
                      @click="phoneHandleBind(phoneFormRef)"
                      :loading="loading"
                    >
                      提交
                    </el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </template>
  </CustDialogBox>
</template>

<script setup>
import { ref } from 'vue'
import { getByUserName, smsLogin, getQrcode, getSignStatus } from '@/api/login'
import { ystSendSmsCode, ystBindBySms } from '@/api/manage/clinicSetting'
import { useUserStore } from '@/store/modules/user'
const userStore = useUserStore()
const emit = defineEmits(['closed', 'update:isShow', 'success'])
const props = defineProps({
  isShow: {
    type: Boolean,
    required: true,
  },
  type: {
    type: String,
    default: 'setting',
  },
})
const tabName = ref('phone')
const loading = ref(false)
// 扫码
const qrcodeImg = ref()
const qrcodeKey = ref()
let loginStatusTimer = null
let qrCodeTimer = null
// 验证码
const phoneFormRef = ref()
const phoneForm = reactive({
  phone: '',
  code: '',
})
const countdown = ref(0)
const isCounting = ref(false)
let timer = null
const buttonText = computed(() => {
  return isCounting.value ? `${countdown.value}秒后重新获取` : '获取验证码'
})
const phoneRules = reactive({
  phone: [
    {
      required: true,
      message: '请输入手机号',
      trigger: 'blur',
    },
    {
      pattern: /^1[3-9]\d{9}$/,
      message: '请输入正确的11位手机号',
      trigger: 'blur',
    },
  ],
  code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
})
// 发送验证码
const sendCode = async () => {
  if (isCounting.value) return
  if (phoneForm.phone.trim().length != 11) {
    ElMessage.warning('请输入正确的手机号')
    return
  }
  startCountdown()
  try {
    const res = await ystSendSmsCode({ mobile: phoneForm.phone })
    if (res.code == 0) {
      if (res.data) {
        ElMessage.success('发送成功')
      } else {
        ElMessage.success('发送失败')
      }
    }
  } catch (error) {
    if (error.code == 2023009012) {
      ElMessageBox.confirm(
        '该手机号未注册医事通，请先注册医事通app，再进行绑定',
        '提示',
        {
          confirmButtonText: '我知道了',
          showCancelButton: false,
          type: 'warning',
        }
      ).then(async () => {})
    }
  }
}
// 60秒倒计时
const startCountdown = () => {
  isCounting.value = true
  countdown.value = 60

  timer = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(timer)
      isCounting.value = false
    }
  }, 1000)
}
// 手机号登录
const phoneHandleBind = async formEl => {
  if (!formEl) return
  loading.value = true
  try {
    await formEl.validate(async (valid, fields) => {
      if (valid) {
        const res = await ystBindBySms({
          mobile: phoneForm.phone,
          code: phoneForm.code,
        })
        if (res.code == 0) {
          ElMessage.success('绑定成功')
          userStore.setBinYishitongInfo()
          emit('success')
          dialogOnCloseFn()
        }
      }
    })
  } catch (error) {
    loading.value = false
  }
  loading.value = false
}
const tabchangeFn = val => {
  if (val == 'phone') {
    clearInterval(qrCodeTimer)
    clearInterval(loginStatusTimer)
  } else {
    twoSecondFn()
  }
}
// 二分钟1次更换二维码
const twoSecondFn = () => {
  if (qrCodeTimer) clearInterval(qrCodeTimer)
  getQrcodeFn()
  qrCodeTimer = setInterval(() => {
    clearInterval(loginStatusTimer)
    getQrcodeFn()
  }, 120000)
}
// 获取二维码
const getQrcodeFn = async () => {
  const res = await getQrcode()
  qrcodeImg.value = res.data.qrCodeUrl
  qrcodeKey.value = res.data.sceneStr
  loginStatusTimer = setInterval(() => {
    loopFn()
  }, 2000)
}
// 扫码状态
const loopFn = async () => {
  const res = await getSignStatus({ eventKey: qrcodeKey.value })
  if (res.code == 0 && res.data.status) {
    scanSuccessFn()
  }
}
// 扫码成功
const scanSuccessFn = async () => {
  const res = await userBindOpenId({ eventKey: qrcodeKey.value })
  if (res.code == 0) {
    ElMessage.success('绑定成功')
    userStore.setOpenId(res.data)
    dialogOnCloseFn()
  }
}
const dialogOpendFn = () => {
  // twoSecondFn()
}
const dialogOnCloseFn = () => {
  emit('closed')
  emit('update:isShow', false)
  clearInterval(loginStatusTimer)
  clearInterval(qrCodeTimer)
  phoneForm.phone = ''
  phoneForm.code = ''
  tabName.value = 'phone'
}
</script>

<style lang="scss" scoped>
// :deep(.el-tabs__nav-scroll) {
//   display: flex;
//   justify-content: center;
// }
.dialog_box {
  width: 300px;
  padding: 0 0 10px 0;
  box-sizing: border-box;
}
.weixin {
  width: 100%;
  height: 280px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .image-weixin {
    width: 200px;
    height: 200px;
    margin: 0 0 12px 0;
    border-radius: 12px;
    padding: 8px;
    border: 1px solid #e4e7ed;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  }

  .qrcode-tip {
    font-size: 13px;
    color: #909399;
    margin-top: 6px;
  }
}
.phoneBox {
  width: 100%;
  height: 280px;
}
.dialog_footer {
  width: 100%;
  text-align: end;
  padding-bottom: 10px;
}
.code-login-form {
  width: 100%;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 10px;
  gap: 15px;

  :deep(.el-input__wrapper) {
    border-radius: 12px;
    padding: 6px 11px;
    height: 42px;
    box-sizing: border-box;
  }

  :deep(.el-input__prefix) {
    .input-icon-font {
      color: #c0c4cc;
      font-size: 16px;
    }
  }

  :deep(.el-select .el-input__wrapper) {
    border-radius: 12px;
    height: 42px;
  }
  :deep(.el-select__wrapper) {
    border-radius: 12px;
    padding: 6px 11px;
    height: 42px;
    box-sizing: border-box;
  }

  :deep(.el-button) {
    border-radius: 12px;
    height: 42px;
    padding: 0 15px;
    font-size: 14px;

    &.code-btn {
      min-width: 100px;
      flex-shrink: 0;
    }

    &.login-btn-full {
      border-radius: 12px;
    }
  }

  .code-input-wrapper {
    display: flex;
    gap: 8px;
    width: 100%;

    .code-input {
      flex: 1;
    }
  }

  .el-form-item {
    margin-bottom: 12px;
    margin-top: 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .login-btn-item {
    margin-top: 80px;
    .login-btn-full {
      width: 100%;
      height: 42px;
      font-size: 14px;
    }
  }

  .remember-pwd-item {
    margin-bottom: 12px;

    .remember-pwd-row {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 13px;
    }
  }
}
</style>
